<template>
  <section class="stepPage">
    <infoUpDown :bread="'Highlights'">
      <el-form ref="ref_form" class="step-main-form" :model="stepForm" label-width="170px">
        <el-form-item v-for="(item, index) in stepForm.checkedType" :key="index" :label="'已选中' + item.name" prop="checkedWords2">
          <checkedTags v-model="item.checkedWords" :tags-options="item.wordOptions" />
        </el-form-item>
      </el-form>

      <div class="checked-container">
        <el-tabs v-model="activeTabsName" class="step-el-tabs" type="card">
          <el-tab-pane v-for="(item, index) in stepForm.checkedType" :key="index" :label="item.name" :name="index.toString()">
            <wordCheckbox v-if="isShowWordCheckBox(item)" :checked-word-ids.sync="item.checkedWords" :word-list="item.wordOptions" />
            <sentenceGroupCheckbox v-else :checked-sentence-group-ids.sync="item.checkedWords" :group-list="item.wordOptions" />
          </el-tab-pane>
        </el-tabs>
        <singleWordDetail :active-tabs-name="activeTabsName" />

      </div>
      <div class="bottom-right-bar">
        <el-button v-if="$store.state.courseStep.stepActive > 0" type="info" @click="preStep">上一步</el-button>
        <el-button v-if="$store.state.courseStep.stepActive < ($store.state.courseStep.stepOptions.length - 1)" type="success" @click="nextStep">下一步</el-button>
      </div>

    </infoUpDown>
  </section>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import checkedTags from '../components/checkedTags.vue'
import wordCheckbox from '../components/wordCheckbox.vue'
import sentenceGroupCheckbox from '../components/sentenceGroupCheckbox.vue'
import singleWordDetail from '../components/singleWordDetail.vue'
// import { getDictoryInfoByCode } from '@/api/api_common.js'
import { addStageCurriculumConf, getStepData } from '@api/courseManagement/api_courseManagement'
export default {
  components: {
    checkedTags,
    wordCheckbox,
    sentenceGroupCheckbox,
    singleWordDetail
  },
  props: {
    timestamp: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {

      activeTabsName: '0',
      currentVoiceUrl: '',
      stepForm: {
        checkedType: []
      },

      rules: {
        checkedWords: [{ type: 'array', required: true, message: '请选择', trigger: 'change' }],
        checkedWords2: [{ type: 'array', required: true, message: '请选择', trigger: 'change' }]
      },
      wordOptions: [],
      wordOptions2: []

    }
  },
  computed: {
    ...mapState('courseStep', ['courseData', 'stepOptions', 'stepActive', 'courseStepOptions']),
    // 当前 已选中类型 传参类型
    checkedTypeParams () {
      return this.courseStepOptions[this.courseData.curriculumType][this.stepOptions[this.stepActive].dicCode]
    }
  },
  watch: {
    timestamp: function (val) {
      this.stepForm.checkedType = _.cloneDeep(this.checkedTypeParams.checkedType)

      this.stepForm.checkedType.forEach((item, index) => {
        this.$store.dispatch('courseStep/getCurriculumType', item).then(res => {
          item.wordOptions = res
        })
      })
      this.getStepData()
    }
  },

  created () {

  },
  methods: {
    isShowWordCheckBox (item) {
      if (item.basicMeans === 'WORD_MEANS') { // 单词
        return true
      } else if (item.basicMeans === 'SENTENCE_PATTERN_MEANS') { // 句型
        return true
      } else if (item.basicMeans === 'HIGH_FREQUENCY_MEANS') { // 高频词
        if (item.isRelation === '1') {
          return true
        } else {
          return false
        }
      } else if (item.basicMeans === 'NATURAL_SPELLING_MEANS') { // 自然拼读
        if (item.isRelation === '1') {
          return true
        } else {
          return false
        }
      } else if (item.basicMeans === 'SENTENCE_PATTERN_GROUP_MEANS') { // 句型组
        if (item.isRelation === '2') {
          return true
        } else {
          return false
        }
      }
    },
    getStepData () {
      const params = {
        dataTypeList: this.checkedTypeParams.checkedType,
        stageType: this.stepOptions[this.stepActive].dicCode,
        teachingCurriculumId: this.courseData.teachingCurriculumId
        // terminalType: this.courseData.terminalType
      }
      const configStr = ['firstIds', 'twoIds', 'threeIds', 'fourIds']
      getStepData(params).then(res => {
        // res 有值，表明之前已经保存过 该步骤
        if (res) {
          this.stepForm.checkedType.forEach((item, index) => {
            item.checkedWords = res[configStr[index]] ? res[configStr[index]] : []
          })
        }
      })
    },
    preStep () {
      this.$emit('preStep')
    },
    nextStep (formName) {
      let validateArr = []
      for (const item of this.stepForm.checkedType) {
        validateArr = validateArr.concat(item.checkedWords)
      }
      if (validateArr.length === 0) {
        this.$message.error('请至少选择一项学习内容')
        return false
      }

      const params = {
        curriculumType: this.courseData.curriculumType,
        teachingCurriculumId: this.courseData.teachingCurriculumId,
        stageType: this.stepOptions[this.stepActive].dicCode
      }

      // if (this.checkedTypeParams.checkedType[0] === 'WORD_MEANS') {
      //   params.wordMeansIds = this.stepForm.checkedWords1.toString()
      // } else if (this.checkedTypeParams.checkedType[0] === 'HIGH_FREQUENCY_SENTENCE_PATTERN_MEANS') {
      //   params.highFrequencyIds = this.stepForm.checkedWords1.toString()
      // } else if (this.checkedTypeParams.checkedType[0] === 'NATURAL_SPELLING_MEANS') {
      //   params.naturalSpellingIds = this.stepForm.checkedWords1.toString()
      // } else if (this.checkedTypeParams.checkedType[0] === 'SENTENCE_PATTERN_GROUP_MEANS') {
      //   params.sentencePatternGroupIds = this.stepForm.checkedWords1.toString()
      // }

      // // 阅读模块，第二个为 自然拼读模块
      // if (this.checkedTypeParams.checkedType.length === 2) {
      //   if (this.checkedTypeParams.checkedType[1] === 'SENTENCE_PATTERN_MEANS') {
      //     params.sentencePatternIds = this.stepForm.checkedWords2.toString()
      //   } else if (this.checkedTypeParams.checkedType[1] === 'SENTENCE_PATTERN_GROUP_MEANS') {
      //     params.sentencePatternGroupIds = this.stepForm.checkedWords2.toString()
      //   }
      // }

      this.stepForm.checkedType.forEach((item, index) => {
        if (item.basicMeans === 'WORD_MEANS') { // 单词
          params.wordMeansIds = item.checkedWords.toString()
        } else if (item.basicMeans === 'SENTENCE_PATTERN_MEANS') { // 句型
          params.sentencePatternIds = item.checkedWords.toString()
        } else if (item.basicMeans === 'HIGH_FREQUENCY_MEANS') { // 高频词
          if (item.isRelation === '1') {
            params.highFrequencyWordIds = item.checkedWords.toString()
          } else {
            params.highFrequencyIds = item.checkedWords.toString()
          }
        } else if (item.basicMeans === 'NATURAL_SPELLING_MEANS') { // 自然拼读
          if (item.isRelation === '1') {
            params.naturalSpellingLetterIds = item.checkedWords.toString()
          } else {
            params.naturalSpellingIds = item.checkedWords.toString()
          }
        } else if (item.basicMeans === 'SENTENCE_PATTERN_GROUP_MEANS') { // 句型组
          if (item.isRelation === '2') {
            params.groupSentencePatternIds = item.checkedWords.toString()
          } else {
            params.sentencePatternGroupIds = item.checkedWords.toString()
          }
        }
      })

      addStageCurriculumConf(params).then(res => {
        this.$message.success('操作成功')
        this.$emit('nextStep')
      })
    }
  }
}
</script>

<style lang='scss'>
.bottom-right-bar{
  text-align: right;
}

.checked-container{
  display: flex;
  .step-el-tabs{
    min-width: 500px;
    flex-shrink: 0;
    flex: 1;
    margin-right: 30px;
  }
  .singleWordDetailComponent{
    flex: 1;
  }
}

</style>
